import React, { useState } from 'react';
import { X } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
type ModalType = 'privacy' | 'terms' | null;
export const Footer = () => {
  const [activeModal, setActiveModal] = useState<ModalType>(null);
  return <>
      <footer className="py-12 px-4 border-t border-sand bg-parchment-dark text-center" data-id="element-40">
        <div className="max-w-4xl mx-auto" data-id="element-41">
          <p className="font-playfair text-2xl text-gold-antique/50 mb-6" data-id="element-42">
            RENACER
          </p>
          <p className="text-sm text-brown-warm/50" data-id="element-43">
            © {new Date().getFullYear()} RENACER: El Protocolo Cuántico. Todos
            los derechos reservados.
          </p>
          <p className="text-xs text-brown-warm/40 mt-4 max-w-2xl mx-auto mb-6" data-id="element-44">
            Este producto no sustituye el consejo médico o psicológico
            profesional. Los resultados pueden variar.
          </p>
          <div className="flex items-center justify-center gap-6" data-id="element-45">
            <button onClick={() => setActiveModal('privacy')} className="text-sm text-brown-warm/50 hover:text-gold-antique transition-colors underline underline-offset-4 decoration-sand hover:decoration-gold/50" data-id="element-46">
              Política de Privacidad
            </button>
            <span className="text-sand-dark" data-id="element-47">|</span>
            <button onClick={() => setActiveModal('terms')} className="text-sm text-brown-warm/50 hover:text-gold-antique transition-colors underline underline-offset-4 decoration-sand hover:decoration-gold/50" data-id="element-48">
              Términos y Condiciones
            </button>
          </div>
        </div>
      </footer>

      {/* Modal Overlay */}
      <AnimatePresence data-id="element-49">
        {activeModal && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brown-espresso/60 backdrop-blur-sm" onClick={() => setActiveModal(null)} data-id="element-50">
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: [0.21, 0.47, 0.32, 0.98]
        }} className="bg-parchment border border-sand rounded-2xl w-full max-w-2xl max-h-[80vh] overflow-hidden shadow-[0_0_60px_rgba(0,0,0,0.15)]" onClick={e => e.stopPropagation()} data-id="element-51">
              {/* Modal Header */}
              <div className="flex items-center justify-between p-6 border-b border-sand" data-id="element-52">
                <h3 className="font-playfair text-xl font-bold text-gold-antique" data-id="element-53">
                  {activeModal === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setActiveModal(null)} className="text-brown-warm/50 hover:text-brown transition-colors p-1 rounded-lg hover:bg-brown/5" data-id="element-54">
                  <X size={20} data-id="element-55" />
                </button>
              </div>

              {/* Modal Body */}
              <div className="p-6 overflow-y-auto max-h-[calc(80vh-80px)] text-brown-warm text-sm leading-relaxed space-y-4" data-id="element-56">
                {activeModal === 'privacy' ? <PrivacyContent data-id="element-57" /> : <TermsContent data-id="element-58" />}
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
};
function PrivacyContent() {
  return <>
      <p className="text-brown-warm/50 text-xs" data-id="element-59">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="text-gold-antique font-semibold text-base mt-4" data-id="element-60">
        1. Información que Recopilamos
      </h4>
      <p data-id="element-61">
        Al adquirir RENACER, recopilamos únicamente la información necesaria
        para procesar tu compra y entregarte el producto digital. Esto incluye
        tu nombre y dirección de correo electrónico.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-62">
        2. Uso de la Información
      </h4>
      <p data-id="element-63">
        Tu información personal se utiliza exclusivamente para: procesar y
        confirmar tu compra, enviarte el acceso al producto digital, y
        comunicarnos contigo en caso de ser necesario respecto a tu compra.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-64">
        3. Protección de Datos
      </h4>
      <p data-id="element-65">
        Implementamos medidas de seguridad técnicas y organizativas para
        proteger tu información personal contra el acceso no autorizado, la
        alteración, divulgación o destrucción.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-66">
        4. Compartir Información
      </h4>
      <p data-id="element-67">
        No vendemos, comercializamos ni transferimos tu información personal a
        terceros. La única excepción son los proveedores de servicios de pago
        que procesan tu transacción de forma segura.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-68">5. Cookies</h4>
      <p data-id="element-69">
        Nuestro sitio puede utilizar cookies para mejorar tu experiencia de
        navegación. Puedes configurar tu navegador para rechazar cookies, aunque
        esto podría afectar algunas funcionalidades.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-70">
        6. Tus Derechos
      </h4>
      <p data-id="element-71">
        Tienes derecho a acceder, rectificar o eliminar tu información personal
        en cualquier momento. También puedes solicitar la limitación del
        tratamiento de tus datos.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-72">
        7. Cambios en esta Política
      </h4>
      <p data-id="element-73">
        Nos reservamos el derecho de actualizar esta política de privacidad en
        cualquier momento. Los cambios serán publicados en esta página con la
        fecha de actualización correspondiente.
      </p>
    </>;
}
function TermsContent() {
  return <>
      <p className="text-brown-warm/50 text-xs" data-id="element-74">
        Última actualización:{' '}
        {new Date().toLocaleDateString('es-ES', {
        year: 'numeric',
        month: 'long',
        day: 'numeric'
      })}
      </p>

      <h4 className="text-gold-antique font-semibold text-base mt-4" data-id="element-75">
        1. Aceptación de los Términos
      </h4>
      <p data-id="element-76">
        Al adquirir y acceder a RENACER: El Protocolo Cuántico, aceptas estos
        términos y condiciones en su totalidad. Si no estás de acuerdo con
        alguno de estos términos, no debes realizar la compra.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-77">
        2. Naturaleza del Producto
      </h4>
      <p data-id="element-78">
        RENACER es un producto digital educativo e informativo. No constituye
        consejo médico, psicológico ni terapéutico profesional. Los resultados
        pueden variar según cada individuo y su nivel de compromiso con las
        prácticas descritas.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-79">
        3. Licencia de Uso
      </h4>
      <p data-id="element-80">
        Al completar tu compra, recibes una licencia personal, intransferible y
        no exclusiva para acceder y utilizar el contenido de RENACER. Queda
        prohibida la reproducción, distribución, modificación o reventa del
        material sin autorización expresa.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-81">
        4. Propiedad Intelectual
      </h4>
      <p data-id="element-82">
        Todo el contenido de RENACER, incluyendo textos, técnicas, metodologías,
        diseños y materiales complementarios, está protegido por derechos de
        autor y es propiedad exclusiva de sus creadores.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-83">
        5. Entrega del Producto
      </h4>
      <p data-id="element-84">
        RENACER es un producto digital que se entrega de forma inmediata a
        través del correo electrónico proporcionado al momento de la compra. Es
        responsabilidad del comprador proporcionar una dirección de correo
        válida.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-85">
        6. Descargo de Responsabilidad
      </h4>
      <p data-id="element-86">
        El contenido de RENACER se ofrece con fines educativos y de desarrollo
        personal. No garantizamos resultados específicos. Si experimentas
        problemas de salud mental o emocional, te recomendamos consultar con un
        profesional de la salud cualificado.
      </p>

      <h4 className="text-gold-antique font-semibold text-base" data-id="element-87">
        7. Modificaciones
      </h4>
      <p data-id="element-88">
        Nos reservamos el derecho de modificar estos términos y condiciones en
        cualquier momento. Las modificaciones entrarán en vigor desde su
        publicación en esta página.
      </p>
    </>;
}